import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  FormProps,
  Row,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { FormikDropdownField } from 'lib/components/formik/FormikDropdown';
import { CSSProperties } from 'styled-components/macro';
import { FlexProps } from 'lib/components/styles/layout';

export enum QUOTIBLE_INTEGRATION_TYPE {
  ELEADS = 'ELeads',
  DEALERSOCKET = 'Dealersocket',
  VINSOLUTIONS = 'Vinsolutions',
  DRIVE_CENTRIC = 'Drive Centric',
  COVIDEO = 'Covideo',
}

export type QuotibleIntegrationType = `${QUOTIBLE_INTEGRATION_TYPE}`;

export const QUOTIBLE_INTEGRATION_TYPE_OPTIONS = Object.values(
  QUOTIBLE_INTEGRATION_TYPE
).map(value => ({
  value: value,
  label: value,
}));

const extendStyles = {
  labelStyles: {
    width: '200px',
    alignItems: 'center',
    maxHeight: '40px',
  },
  mainWrapper: { flexDirection: 'row' },
} as {
  labelStyles: CSSProperties;
  mainWrapper: FlexProps;
};

export const QuotibleSection = (props: FormProps) => {
  const { setFieldValue, values } = props;
  return (
    <Section>
      <SectionTitle>Quotible</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='quotibleAccess'
          label='Enable Quotible'
          onChange={() => {
            if (values.quotibleAccess) {
              setFieldValue('quotibleLandingUrl', '');
              setFieldValue('quotibleIntegrationType', '');
            }
            setFieldValue('quotibleAccess', !values.quotibleAccess);
          }}
        />

        {!!values.quotibleAccess && (
          <Row>
            <FormikInputField
              name='quotibleLandingUrl'
              label='Quotible Landing URL'
              isRequired={false}
              extendStyles={extendStyles}
            />
          </Row>
        )}
        {!!values.quotibleAccess && (
          <Row>
            <FormikDropdownField
              name='quotibleIntegrationType'
              options={QUOTIBLE_INTEGRATION_TYPE_OPTIONS}
              label={'Quotible Integration Type'}
              extendStyles={extendStyles}
              isRequired={false}
            />
          </Row>
        )}
      </RowWrapper>
    </Section>
  );
};
